import styled from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconChevronDown } from '@sorare/core/src/atoms/icons/system/iconChevronDown.ts';
import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { range } from '@sorare/core/src/lib/arrays';

const Root = styled(Vertical).attrs({ gap: 4 })`
  padding: var(--double-unit);
`;
const TaskSkeleton = styled(Skeleton)`
  width: 100%;
  height: 100px;
`;
const TextSkeleton = styled(Skeleton)`
  height: var(--double-and-a-half-unit);
  border-radius: var(--double-unit);
`;

export const MissionPageSkeleton = () => {
  return (
    <Root>
      {range(3).map(i => (
        <Vertical key={i}>
          <SBHorizontal>
            <Vertical style={{ flex: 1 }}>
              <TextSkeleton style={{ width: '30%' }} />
              <TextSkeleton style={{ width: '70%' }} />
            </Vertical>
            <FontAwesomeIcon icon={iconChevronDown} />
          </SBHorizontal>
          <TaskSkeleton />
          <TaskSkeleton />
        </Vertical>
      ))}
    </Root>
  );
};
